import { Wizard } from '@/components/layout/Wizard';
import { Background, Container } from '@/components/wm';
import { setStoreResource } from '@/utils/store';
import React from 'react';
import { Configuration } from '../Configuration';
import { Properties } from './Content/Properties';
import { SelectAssets } from './Content/SelectAssets';

export default function CreateIntegration ({ license }) {
    const initialData = {
        assetsAttributes: [],
        configurationId: '',
        indicatorId: '',
        licenseId: license.id,
        name: '',
        partnerId: license.partner_id,
        siteId: '',
        workTypeReference: ''
    };

    const steps = [
        { Component: Properties, title: i18next.t('integrations.new_integration'), description: i18next.t('integrations.nextbitt.properties_description') },
        { Component: SelectAssets, title: i18next.t('integrations.new_integration'), description: i18next.t('integrations.nextbitt.select_assets_description') },
        { Component: Configuration, title: i18next.t('integrations.new_integration'), description: i18next.t('integrations.nextbitt.configuration_description') }
    ];

    const handleSubmit = async data => {
        return await setStoreResource('integrations', data);
    };

    return (
        <Background>
            <Container>
                <Wizard
                    handleSubmit={handleSubmit}
                    initialData={initialData}
                    steps={steps}
                />
            </Container>
        </Background>
    );
}
